export { default as Dataset } from './Dataset.js';
export { default as DatasetInfo } from './DatasetInfo.js';
export { default as DatasetItem } from './DatasetItem.js';
export { default as DatasetPager } from './DatasetPager.js';
export { default as DatasetSearch } from './DatasetSearch.js';
export { default as DatasetShow } from './DatasetShow.js';
import './index-e93a2314.js';
import './normalize-component-1efcb3aa.js';
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-dataset/dist/es/index.js
// module id = 749
// module chunks = 3